module.exports = __webpack_public_path__ + "static/media/poemiconhover.87a569a3.svg";